<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">{{ title }}</h4>
                <button ref="closeCreateRFCModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
                <form ref="fiel_form" id="fiel_form" method="POST" enctype="multipart/form-data" autocomplete="off">
                    <div v-if="formError" class="alert alert-danger" role="alert">{{ formError }}</div>
                    <div class="form">
                        <input type="text" style="display:none" autocomplete="username" />
                        <input type="password" style="display:none" autocomplete="current-password" />
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="mb-3">
                                    <label>Certificado (.cer):</label>
                                    <input class="form-control" type="file" id="cer_file" name="cer_file" accept=".cer" placeholder="" autocomplete="off" @change="loadCertificate">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="mb-3">
                                    <label>Clave privada (.key):</label>
                                    <input class="form-control" type="file" id="key_file" name="key_file" accept=".key" placeholder="" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="mb-3">
                                    <label>Contraseña de clave privada:</label>
                                    <input class="form-control" v-model="password" type="password" id="fiel_password" name="fiel_password" placeholder="" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mb-3">
                                    <label>RFC:</label>
                                    <input class="form-control" v-model="rfc" type="text" id="rfc" name="rfc" placeholder="" autocomplete="off" readonly style="background-color: #e9ecef;">
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="mb-3">
                                    <label>Nombre o Razón Social:</label>
                                    <input class="form-control" v-model="name" type="text" id="name" name="name" placeholder="" autocomplete="off" readonly style="background-color: #e9ecef;">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="mb-3">
                                    <label>Vigencia del Certificado:</label>
                                    <input class="form-control" v-model="start_date" type="text" id="start_date" name="start_date" placeholder="" autocomplete="off" readonly style="background-color: #e9ecef;">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="mb-3">
                                    <label>&nbsp;</label>
                                    <input class="form-control" v-model="end_date" type="text" id="end_date" name="end_date" placeholder="" autocomplete="off" readonly style="background-color: #e9ecef;">
                                </div>
                            </div>
                        </div> 
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="storeRFC">{{ action }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/rfcs'

import forge from 'node-forge';
 
export default {
    name: 'create_rfc_modal',
    mixins: [],
    props: {

    },
    components: {
        
    },
    data(){
        return {
            title: 'Nuevo RFC',
            action: 'Registrar',
            showModal: true,
            rfc: '',
            name: '',
            password: '',
            start_date: '',
            end_date: '',
            formError: ''
        }
    },
    methods: {
        loadModal(rfc, title, action){
            this.formError = '';
            this.rfc = rfc;
            this.title = title;
            this.action = action;
        },
        async storeRFC() {
            this.formError = '';
            const form = document.getElementById("fiel_form");
            const formData = new FormData(form);

            let response = await ws.storeRFC(formData);

            if(response.type == "success"){
                this.$emit("refresh",response.data);
                
                this.$toast.success(response.message);

                localStorage.setItem('rfcs', JSON.stringify(response.plucks));

                this.closeModal();
            }
            else{
                this.formError = response.message || 'No se pudo registrar el RFC.';
            }
        },
        async loadCertificate(e){
            const file = e.target.files[0];

            const arrayBuffer = await file.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            let binary = '';
            for (let i = 0; i < uint8Array.byteLength; i++) {
                binary += String.fromCharCode(uint8Array[i]);
            }

            try {
                const der = forge.util.createBuffer(binary, 'raw');
                const asn1 = forge.asn1.fromDer(der);
                const cert = forge.pki.certificateFromAsn1(asn1);

                const subjectAttrs = cert.subject.attributes;

                const rfcAttr = subjectAttrs.find(attr => attr.type === '2.5.4.45'); // RFC
                const nameAttr = subjectAttrs.find(attr => attr.type === '2.5.4.3');  // Nombre
                
                const rfcAttrParts = (rfcAttr?.value || '')
                    .split('/')
                    .map(part => part.trim())
                    .filter(Boolean);
                    
                const parsedRfc = rfcAttrParts[0] || '';
                const parsedNameFromRfc = rfcAttrParts[1] || '';

                if(this.rfc != ''){
                    if(this.rfc != parsedRfc){
                        this.formError = 'La eFirma no le pertenece al RFC seleccionado.';
                        return;
                    }
                }
                else{
                    this.rfc = parsedRfc;
                }

                this.name = nameAttr ? nameAttr.value : parsedNameFromRfc;

                const notBefore = cert.validity.notBefore;
                const notAfter  = cert.validity.notAfter;

                const formatDate = d => d.toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });

                this.start_date = formatDate(notBefore);
                this.end_date = formatDate(notAfter);

            } catch (err) {
                console.error('Error leyendo el .cer:', err);
            }
        },
        closeModal(){
            this.$refs.closeCreateRFCModal.click();

            this.rfc = '';
            this.name = '';
            this.password = '';
            this.start_date = '';
            this.end_date = '';
            this.formError = '';

            this.$refs.fiel_form.reset();
        }
    }
}
</script>